import React, { useState } from "react";
// import alertIcon from "../../../images/alert.png";
import useStyles from "../../../../components/common/model/styles";
import Popup from "../../../../components/common/model/Popup";
import { Alert, DialogContent, DialogContentText } from "@mui/material";
import closeIcon from "../../../../assets/closeModel.png";
import CustomButton from "../../../../components/common/button/CustomButton";
import { useDispatch } from "react-redux";
import {
  getActivationToggleAction,
  initialClientLocalState,
  resetNewClientLocal,
  setClientForEditAction,
  setPlanClientAction,
} from "../../../../store/reducers/adminClientsSlice";
import { useSelector } from "react-redux";
interface ActivationPopupProps {
  title?: string;
  open: boolean;
  onHide?: () => void;
  clientDetails?: any;
  setFormData?: any;
  alertModalShow: boolean;
  setAlertModelShow: (show: boolean) => void;
  setShowSuccessMessage?: (message: string) => void;
  companyProfileResetAllValidator: any;
  action?: any;
  setIsImageReset?: any;
}
const ResetFormAlert: React.FC<ActivationPopupProps> = ({
  onHide,
  alertModalShow,
  setAlertModelShow,
  setFormData,
  companyProfileResetAllValidator,
  action,
  setIsImageReset
}) => {
  const [isAction, setIsAction] = useState(false);
  const dispatch = useDispatch();
  const classes = useStyles();
  const { editClientOriginalData, editPlanOriginalData } = useSelector((state: any) => state?.adminClients);
  const submitHandler = () => {
    setFormData(initialClientLocalState);
    if(action === 'edit') {
      dispatch(setClientForEditAction(editClientOriginalData));
      setIsImageReset && setIsImageReset(true);
    } else if(action === 'plan') {
      dispatch(setPlanClientAction(editPlanOriginalData));
    } else {
      dispatch(resetNewClientLocal());
      setIsImageReset && setIsImageReset(true);
    }
    setAlertModelShow(false);
    companyProfileResetAllValidator();
  };
  const closeModel = () => {
    setAlertModelShow(false);
  };
  const [fullWidth, setFullWidth] = useState(true);
  const [maxWidth, setMaxWidth] = useState<
    "sm" | "xs" | "md" | "lg" | "xl" | false
  >("xs"); // Adjust the type definition
  return (
    <Popup
      open={alertModalShow}
      title={"Alert"}
      onHide={closeModel}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      aria-describedby="alert-dialog-slide-description"
      header={
        <>
          <img
            onClick={closeModel}
            src={closeIcon}
            className={classes.closeicons}
            alt="close"
          />
        </>
      }
      footer={
        <>
          <CustomButton variant="outlined" title="No" onClick={closeModel} />
          <CustomButton title="Yes" onClick={submitHandler} />
        </>
      }
    >
      <DialogContent sx={{ padding: "0px" }}>
        <DialogContentText>
          {/* <img src={alertIcon} alt="icons" /> */}
          {isAction ? (
            <Alert severity="error">
              {isAction || "Access denied! Please try again"}
            </Alert>
          ) : (
            <Alert
              sx={{ bgcolor: "#eeecef", fontSize: "16px" }}
              severity="warning"
            >
              Are you sure, you want to delete the data you have just entered?
            </Alert>
          )}
        </DialogContentText>
      </DialogContent>
    </Popup>
  );
};

export default ResetFormAlert;
